import React, { useEffect, useState } from 'react';
import { Radio, X, Play } from 'lucide-react';
import { getLive } from '../lib/api';

export default function LiveBanner() {
  const [live, setLive] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchLive = () => getLive().then((d) => { if (!cancelled) setLive(d); }).catch(() => {});
    fetchLive();
    const t = setInterval(fetchLive, 15000);
    const onChange = () => fetchLive();
    window.addEventListener('live-changed', onChange);
    return () => { cancelled = true; clearInterval(t); window.removeEventListener('live-changed', onChange); };
  }, []);

  if (!live || !live.is_live) return null;

  const isYouTube = live.platform === 'youtube' && live.embed;
  const label = live.platform === 'instagram' ? 'Instagram' : live.platform === 'linkedin' ? 'LinkedIn' : 'YouTube';

  return (
    <div data-testid="live-banner" className="sticky top-0 z-[60]">
      <div className="bg-[#E11D2A] text-white">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-2.5 flex items-center gap-3">
          <span className="flex items-center gap-2 font-semibold text-sm tracking-tight">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
            </span>
            <Radio size={16} /> LIVE NOW
          </span>
          <span className="text-sm text-white/90 truncate flex-1 min-w-0">{live.title || `Rajni is live on ${label}`}</span>
          {isYouTube ? (
            <button
              data-testid="live-watch-btn"
              onClick={() => setOpen((o) => !o)}
              className="shrink-0 bg-white text-[#E11D2A] font-semibold text-sm px-4 py-1.5 rounded-full inline-flex items-center gap-1.5 hover:bg-white/90 transition-colors"
            >
              {open ? <><X size={15} /> Close</> : <><Play size={15} /> Watch</>}
            </button>
          ) : (
            <a
              data-testid="live-watch-link"
              href={live.url}
              target="_blank"
              rel="noreferrer"
              className="shrink-0 bg-white text-[#E11D2A] font-semibold text-sm px-4 py-1.5 rounded-full inline-flex items-center gap-1.5 hover:bg-white/90 transition-colors"
            >
              <Play size={15} /> Watch on {label}
            </a>
          )}
        </div>
      </div>
      {isYouTube && open && (
        <div className="bg-black">
          <div className="max-w-4xl mx-auto">
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                data-testid="live-embed"
                title="Live stream"
                src={`${live.embed}?autoplay=1`}
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
